import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';
import { Tabs } from '@cian/ui-kit/prev';

import * as styles from './styles.css';
import { IHousesByTurn } from '../../../../types/newbuilding/housesByTurn';
import { ISpecificationsDetailed } from '../../../../types/newbuilding/specificationsDetailed';
import { HousesByTurn } from '../../../HousesByTurn';
import { SpecificationsDetailed } from '../../../SpecificationsDetailed';

interface ISpecificationsPopupContentProps {
  newbuildingName: string;
  specifications: ISpecificationsDetailed;
  housesByTurn: IHousesByTurn[];
}

const SPECIFICATIONS_POPUP_TABS = [{ title: 'Характеристики' }, { title: 'Сдача корпусов' }];

export function SpecificationsPopupContent({
  newbuildingName,
  specifications,
  housesByTurn,
}: ISpecificationsPopupContentProps) {
  const [activeTab, setActiveTab] = React.useState<string>('0');

  const onTabClick = React.useCallback((index: string) => {
    setActiveTab(index);
  }, []);

  return (
    <>
      <div className={styles['header']}>
        <ArticleHeading1 as="h1">{`Характеристики ${newbuildingName}`}</ArticleHeading1>
      </div>
      {specifications && housesByTurn.length > 0 && (
        <div className={styles['tabs']}>
          <Tabs
            activeTab={activeTab}
            onChange={onTabClick}
            tabs={SPECIFICATIONS_POPUP_TABS.map((item, index) => ({
              value: String(index),
              title: item.title,
            }))}
          />
        </div>
      )}
      {(housesByTurn.length === 0 || activeTab === '0') && <SpecificationsDetailed {...specifications} />}
      {(!specifications || activeTab === '1') && <HousesByTurn housesByTurn={housesByTurn} />}
    </>
  );
}
